export class PagingHeader {
    TotalItems: number = 0;
    PageNumber: number = 0;
    PageSize: number = 0;
    TotalPages: number = 0;
}

export interface LinkInfo {
    PageNumber: number;
    PageSize: number;
    Rel: string;
    Method: string;
}

export class QueryStringParameters {
    MaxPageSize: number = 0;
    SearchQuery: string = "";
    PageNumber: number = 0;
    PageSize: number = 0;
    OrderBy: string =  'id'
    OrderDir: string =  'desc'
    SelectedValue:string = 'All'
}